import { render, staticRenderFns } from "./MallPage.vue?vue&type=template&id=3f2aeba7&scoped=true"
import script from "./MallPage.vue?vue&type=script&lang=js"
export * from "./MallPage.vue?vue&type=script&lang=js"
import style0 from "./MallPage.vue?vue&type=style&index=0&id=3f2aeba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2aeba7",
  null
  
)

export default component.exports